import React from 'react'
import { FarmContextValue } from 'src/Elements/Farm/types'

export const FarmContext = React.createContext<FarmContextValue | undefined>(undefined)
